export const mutationType = {
  GET_USER_PROFILE: 'GET_USER_PROFILE',
  GET_USER_LINE: 'GET_USER_LINE',
  SET_USER_META_DATA: 'SET_USER_META_DATA',
  REMOVE_USER_META_DATA: 'REMOVE_USER_META_DATA',
  PUT_USER: 'PUT_USER',
  SET_LINE_ID: 'SET_LINE_ID',
}
